import produce from 'immer';

import { ExchangeVariantsState } from '../types';
import {
	addSelectedFlight,
	setExchangeVariants,
	removeLastSelectedFlight,
	clearExchangeVariants,
	SetExchangeVariantsAction,
	AddSelectedFlightAction,
	RemoveLastSelectedFlightAction,
	ClearExchangeVariantsAction,
	SetExchangeVariantPrices,
	setExchangeVariantPrices,
	setActualSelectedFlightPriceId
} from './actions';

const initialState: ExchangeVariantsState = {
	selectedFlights: [],
	flightDirections: [],
	exchangeVariantPriceInfo: []
};

function exchangeVariantsReducer(
	state = initialState,
	{
		type,
		payload
	}:
		| SetExchangeVariantsAction
		| SetExchangeVariantPrices
		| AddSelectedFlightAction
		| RemoveLastSelectedFlightAction
		| ClearExchangeVariantsAction
) {
	return produce(state, draft => {
		switch (type) {
			case addSelectedFlight.toString():
				draft.selectedFlights.push(payload);
				break;
			case setActualSelectedFlightPriceId.toString():
				draft.selectedFlights = draft.selectedFlights.map(selectedFlight =>
					selectedFlight.priceId === payload.priceId
						? { ...selectedFlight, actualPriceId: payload.actualPriceId }
						: selectedFlight
				);
				break;
			case setExchangeVariants.toString():
				draft.flightDirections = payload.flightDirections;
				draft.exchangeVariantPriceInfo = payload.exchangeVariantPriceInfo;
				break;
			case setExchangeVariantPrices.toString():
				draft.exchangeVariantPriceInfo = payload;
				break;
			case removeLastSelectedFlight.toString():
				draft.selectedFlights.pop();
				break;
			case clearExchangeVariants.toString():
				draft.selectedFlights = [];
				draft.flightDirections = [];
				draft.exchangeVariantPriceInfo = [];
				break;
		}
	});
}

export default exchangeVariantsReducer;
